import cxCheckBoxClasses from './ccf-checkbox.module.scss';
import {
  FormControlLabel,
  Checkbox
} from '@mui/material';

import {
  CcfCheckBoxIcon,
  CcfCheckBoxOutlineBlankIcon,
  useTranslator
} from '@nice-ccf/ui-controls';

/* eslint-disable-next-line */

interface VoicePrefCheckbox {
  checkboxVal: boolean;
}
/* eslint-disable-next-line */
export interface CcfCheckboxProps { 
  onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  options: VoicePrefCheckbox
}

/**
 * Component used to display checkbox
 * @param props - CcfCheckboxProps
 * @example <CcfCheckbox />
 * @returns checkbox
 */
export function CcfCheckbox(props: CcfCheckboxProps) {
  const{onCheckboxChange,options} = props
  const [translate] = useTranslator();
  const rememberPreference = translate('rememberPreference');

  return (
    <div className={cxCheckBoxClasses['cxOneCheckboxControl']}>
      <FormControlLabel
        value="rememberPreference"
        checked={options.checkboxVal}
        control={
          <Checkbox
            color="primary"
            icon={<CcfCheckBoxOutlineBlankIcon />}
            checkedIcon={<CcfCheckBoxIcon />}
            onChange={onCheckboxChange}
          />
        }
        label={rememberPreference}
        labelPlacement="end"
      />
    </div>
  );
}

export default CcfCheckbox;
